import React, { useState, useEffect,useRef } from 'react';
import {urlApiProd,print,correoUsuario,formatYYYYMMDD,capitalizeFirstLetter,handleEliminar,handleAgregar} from '../utiles';
import { Modal, Button, Spinner, Badge, Card,Form,Row,Alert,Table,Container,Col,InputGroup,Accordion,ListGroup } from 'react-bootstrap';
import moment from 'moment';
import { IoTrashOutline,IoDownloadOutline } from "react-icons/io5";
import { toast, ToastContainer } from 'react-toastify';
import DataTable from 'react-data-table-component';
import { LuPencilLine } from "react-icons/lu";


const GestionCPO = ({ desde, solicitud, puertos, ffw, carriers,  cerrar }) => {
const [formDataAntigua, setFormDataAntigua] = useState({ ...solicitud });
const [formData, setFormData] = useState({ ...solicitud });
const [show, setShow] = React.useState(true);
const [dataHistoria, setdataHistoria] = useState([]);
const [usuarioCreador, setUsuarioCreador] = React.useState(undefined);
const [mapa,setMAPA] = React.useState(solicitud.mapa);
const [erroresForm, seterroresForm] = useState('');
const [showguardarArchivo, setShowguardarArchivo] = React.useState(false);
const [dataDocumentos,setDocumentos] = useState([]);
const [dataClientes,setClientes] = useState([]);
const [dataClientesBooking,setClientesBooking] = useState([]);
const [dataProveedores,setProveedores] = useState([]);
const [DataBookingProveedores,setDataBookingProveedores] = useState([]);
const [loading, setLoading] = useState(true);
const [DataBookingProformas,setDataBookingProformas] = useState([]);
const [dataNombresProductos,setDataNombresProductos] = useState([]);
const [dataBookingProducto,setDataBookingProducto] = useState([]);
const [dataBookingContenedor,setDataBookingContenedor] = useState([]);
const [nombreContenedor, setnombreContenedor] = useState('');
const [fechaRetiro, setfechaRetiro] = useState(undefined);
const [fechaIngresoPuerto, setfechaIngresoPuerto] = useState(undefined);
const [dataBookingFecha,setDataBookingFecha] = useState([]);

useEffect(() => {
    fetchDataClientes();
    fetchDataProveedores();
    fetchDataNombreProductos();
    fetchDataBookingContenedor();
    fetchDataBookingFecha();
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    fetchDataDocumentos();
    fetchDataHistoria();

setLoading(false);

  };

  const fetchDataBookingFecha = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/bookingfecha/${formData.id_solicitud}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching setDataBookingFecha');
        const data = await response.json();
        setDataBookingFecha(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`setDataBookingFecha no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};
  
  const fetchDataBookingContenedor = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/bookingclientecontenedor/${formData.id_solicitud}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching setDataBookingContenedor');
        const data = await response.json();
        setDataBookingContenedor(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`setDataBookingContenedor no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

  const fetchDataNombreProductos = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/nombreproductos`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching fetchDataNombreProductos');
        const data = await response.json();
        setDataNombresProductos(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`fetchDataNombreProductos no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

  const fetchDataBookingProformas = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/bookingproforma/${formData.id_solicitud}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching DataBookingProveedores');
        const data = await response.json();
        setDataBookingProformas(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`DataBookingProveedores no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

  const fetchDataBookingProveedor = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/bookingproveedores/${formData.id_solicitud}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching DataBookingProveedores');
        const data = await response.json();
        setDataBookingProveedores(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`DataBookingProveedores no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

const fetchDataProveedores = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/proveedores`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching proveedores');
        const data = await response.json();
        setProveedores(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`proveedores no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

const fetchDataClientesBooking = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/bookingclientesbooking/${formData.id_solicitud}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching bookingclientesbooking');
        const data = await response.json();
        setClientesBooking(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`bookingclientesbooking no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
    
};

const fetchDataClientes = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/clientes`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching clientes');
        const data = await response.json();
        setClientes(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`clientes no cargados: ${error.message}`, { toastId: 'error-principal' });
    } 
};
      
const handleCloseguardarArchivo = () => {
    fetchDataDocumentos();
    setShowguardarArchivo(false);};
const handleShowguardarArchivo = () => setShowguardarArchivo(true);

function timeout(delay) {
    return new Promise( res => setTimeout(res, delay) );
}

const handleUploadFileServer = async (e) => {
    const file = e.target.files[0];
    print(file);

    if(file.size<5000000){
        const token = localStorage.getItem('token');
    const fd = new FormData()
    fd.append('file', file)
    fd.append('nombre',file.name)
    fd.append('ruta','bookingexterno')
    fd.append('idObjeto',formData.id_solicitud)
    fd.append('usuario_creador',localStorage.getItem('ID_Usuario'))
    fd.append('mail_usuario_creador',localStorage.getItem('correo'))

    const response = await fetch(`${urlApiProd}/subirarchivo`, {
        headers: { 'Authorization': `Bearer ${token}` },
        method: "POST",
        body: fd
    });

    if (response.ok){
    var r = await response.json();
    print(`response ${JSON.stringify(r)}`);
    alert("Archivo guardado correctamente");
    fetchDataDocumentos();

    } else{
        print("error subiendo archivo");
    }
    
} else{
    alert("Archivo muy grande, favor comprimir o disminuir tamaño. Max 5MB");
}
        
}

const GuardarArchivo = () => {

        return (
          <>
            <Button variant="primary"  style={{marginTop:5, width:200}} onClick={handleShowguardarArchivo}>
                    Documentación de Booking
             </Button>
      
            <Modal size='lg' show={showguardarArchivo} onHide={handleCloseguardarArchivo} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>Documentación de Booking</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <DataTable
                                columns={columns}
                                data={dataDocumentos}
                                pagination
                                paginationPerPage={10}
                                highlightOnHover
                                responsive
                            />
                            <p></p>
              Cargar nuevo archivo          
              <input type="file" onChange={handleUploadFileServer} />
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseguardarArchivo}>
                  Volver
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        );
      };

          const fetchDataDocumentos = async () => {
              const token = localStorage.getItem('token');
              try {
                  // Fetch Solicitudes Internas
                  const responsedocumentos = await fetch(`${urlApiProd}/documentosbooking`, {
                      headers: { 'Authorization': `Bearer ${token}` }
                  });
                  if (!responsedocumentos.ok) throw new Error('Error fetching preciosfletes');
                  const data= await responsedocumentos.json();
                  setDocumentos(data);
              } catch (error) {
                  console.error('Error en fetchData:', error.message);
                  toast.error(`documentos no cargados: ${error.message}`, { toastId: 'error-principal' });
              } finally{return true;}
          };



const fetchDataHistoria = async () => {
    setUsuarioCreador(await correoUsuario(formData.id_creador));
            const token = localStorage.getItem('token');
            try {
                // Fetch Solicitudes Internas
                const response = await fetch(`${urlApiProd}/historias/booking/${formData.id_solicitud}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error('Error fetching datos hisotrias');
                const data= await response.json();
                data.reverse();
                //print(`'Edata:', ${data}`);
                setdataHistoria(data);
                //setTotalItems(total);
                //setPrincipal(true);
            } catch (error) {
                print(`'Error en fetchData:', ${error.message}`);
                //setPrincipal(false); // Indica que la solicitud principal falló
                print(`historias no cargadas: ${error.message} { toastId: 'error-principal' }`);
            }
        };

const handleDownloadFile = async (row) => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${urlApiProd}/descargardocumento/${row.id}`, {
            method: 'POST',
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {throw new Error('Error descargando documento');}
        else {


            const buffer = await response.arrayBuffer();
            const bytes = new Uint8Array(buffer);
            const blob = new Blob([bytes]);
            const formatedURL = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = formatedURL;
            link.setAttribute('download',row.nombre);
            document.body.appendChild(link);
            link.click();

            //print(`descargado ok ${bytes}`);
        }

        //fetchDataDocumentos();
    } catch (error) {
        console.error('Error:', error);
        alert('No fue posible descargar documento');
    }
}

        const columns = [
            { name: 'Nombre', selector: row => row.nombre,  sortable: true,reorder: true },
            { name: 'Fecha Creación', selector: row => row.fecha_creacion ? formatYYYYMMDD(row.fecha_creacion) : '',  sortable: true,reorder: true },
            { name: 'Usuario Creador', selector: row => row.mail_usuario_creador,  sortable: true,reorder: true },
            { name: 'Acciones',
                        cell: row => (
                            <div >
                                 <button className='btn btn-outline-primary mr-2' onClick={() => handleDownloadFile(row)} style={{ flex: 1, marginRight: 10 }}>
                                                            <IoDownloadOutline />
                                                        </button>
                                    <button
                                        className='btn btn-outline-danger'
                                        onClick={() => {
                                            if (window.confirm('¿Estás seguro de eliminar documento?')) {
                                                handleEliminarDoc(row.id);
                                            }
                                        }} 
                                    >
                                        <IoTrashOutline />
                                    </button>
                                   
                            </div>
                        ),
                        ignoreRowClick: true,
                    }
        ];   
        
              const handleEliminarDoc = async (id) => {
                const token = localStorage.getItem('token');
                try {
                    const response = await fetch(`${urlApiProd}/eliminardocumentobooking/${id}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            usuario_elimina: localStorage.getItem('ID_Usuario')
                        }),

                    });
                    if (!response.ok) throw new Error('Error eliminando documento');
                    alert('Documento eliminado exitosamente');
                    fetchDataDocumentos();
                    return true;
                } catch (error) {
                    console.error('Error:', error);
                    alert('No se pudo eliminar documento');
                }
            };

    const handleClose = () => {setShow(false);
        cerrar();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        //print(`name ${name} value ${value} `);
    };

    const handleChangeUpperCase = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value.toUpperCase() });
    };

    const handleChangeCantidad = (e, maxi) => {
        const { name, value,min,max } = e.target;
        var value1 = 0;

        if(Number(value)<Number(maxi)){
            value1 = Number(value);     
            setFormData({ ...formData, [name]: value1>0 ? Number(value1) : '' });
        }
    }

    const handleChangeCantidadInvoice = (e, maxi) => {
        const { name, value,min,max } = e.target;
        var value1 = 0;

        if(Number(value)<Number(maxi)){
            value1 = Number(value);     
            setFormData({ ...formData, [name]: value1>0 ? Number(value1) : '' });
        }
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.codigo.trim() || formData.id_puerto_origen===-1 || formData.id_puerto_destino===-1 || !formData.etd || !formData.cantidad || !formData.flete || formData.id_carrier===-1 || !formData.cantidad) {
            // alert('Por favor, complete todos los campos obligatorios.');
             seterroresForm('⚠️ Favor revisar información ⚠️');
             await timeout(2000);
             seterroresForm('');
             return;
         }

         if(((formData.categoria_booking==='' || formData.categoria_booking===null || formData.categoria_booking===-1)) && formData.estado.toString()==="3"){
            seterroresForm('⚠️ Falta Categoría de Booking ⚠️');
             await timeout(2000);
             seterroresForm('');
             return;
         }

         
         if(((formData.mapa==='' || formData.mapa===null || formData.mapa===-1)) && formData.estado.toString()==="3"){
            seterroresForm('⚠️ Falta Indicar MAPA ⚠️');
             await timeout(2000);
             seterroresForm('');
             return;
         }

         /*
         const found = arr.some(el => el.username === name);
         if(formData.invoice.toString()!=='0' && !found){

         }
         */
         if(formData.invoice===''){
          formData.invoice=0;
    }
         if(formData.dlc===''){
            formData.dlc=null;
      }
      if(formData.dld===''){
        formData.dld=null;
  }
  if(formData.eta===''){
    formData.eta=null;
}
  if(formData.estado_bl===''){
    formData.estado_bl=null;
}



        const token = localStorage.getItem('token');

       var tifOptions = [];

        Object.keys(formDataAntigua).forEach(function(key) {
            if(key!=='solicitud_interna' && formDataAntigua[key]!==formData[key])
                tifOptions.push("algo"); 
        });

        print(`tifOptions ${tifOptions.length}`);

     //if  
     if(tifOptions.length>0){
        try {
            const response = await fetch(`${urlApiProd}/editsolicitudbooking/${solicitud.id_solicitud}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });


            if (response.ok){ 
                print(moment());
                print(JSON.stringify({tabla : 'booking', objeto_anterior : JSON.stringify(formDataAntigua), objeto_actual: JSON.stringify(formData), fecha: moment(), usuario_modifica: localStorage.getItem('correo'), usuario_modifica_id : localStorage.getItem('ID_Usuario'), id_objeto: formData.id_solicitud}));
                try {
                    const response1 = await fetch(`${urlApiProd}/add_historia`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({tabla : 'booking', objeto_anterior : JSON.stringify(formDataAntigua), objeto_actual: JSON.stringify(formData), fecha: moment(), usuario_modifica: localStorage.getItem('correo'), usuario_modifica_id : localStorage.getItem('ID_Usuario'), id_objeto: formData.id_solicitud})
                    });
        
        
                    if (response1.ok){ 
        
                        alert('Solicitud editada exitosamente');
        
                    } else { 

                    //throw new Error('Error al editar la solicitud');
                    alert('Error al crear historia');
                     }
        
        
                    cerrar();
                } catch (error) {
                    console.error('Error:', error);
                }

            } else {
              const r = await response.json();
                print(`response ${r.error}`); 
            //throw new Error('Error al editar la solicitud');
            alert(r.error);
             }


           // cerrar();
        } catch (error) {
            console.error('Error:', error);
            alert('No se pudo editar la solicitud');
        }
    } else{
        seterroresForm('⚠️ No hay cambios realizados ⚠️');
        await timeout(2000);
        seterroresForm('');
    }

    };

    const handleChangeLimited = (e, max) => {
        const { name, value } = e.target;
    
        // Asegurar que no supere el máximo permitido
        if (value <= max) {
            setFormData({
                ...formData,
                [name]: value,
            });
        } else {
            alert(`El valor máximo permitido es ${max} días.`);
        }
    };

    //console.log("ID FFW:", formData.id_ffw);
    //clientes
    const [results, setResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState("");
    const [isNameSelected, setIsNameSelected] = useState(false);
    const [containers, setContainers] = useState("");

    //proveedores
    const [resultsproveedores, setResultsproveedores] = useState([]);
    const [nameproveedores, setNameproveedores] = useState("");
    const [isNameSelectedproveedores, setIsNameSelectedproveedores] = useState(false);
    const [containersproveedores, setContainersproveedores] = useState("");

    //proforma
    const [containersproforma, setContainersproforma] = useState("");
    const [proformaID, setProformaID] = useState("");

        //producto
        const [resultsproducto, setResultsproducto] = useState([]);
        const [nameproducto, setNameproducto] = useState("");
        const [isNameSelectedproducto, setIsNameSelectedproducto] = useState(false);
        const [containersproducto, setContainersproducto] = useState("");
  
      const mockResultsClientes = (keyword) => {
        return new Promise((res, rej) => {
          setTimeout(() => {
            const searchResults = dataClientes.filter((item) => item.nombre.toUpperCase().includes(keyword.toUpperCase()));
            res(searchResults);
          }, 500);
        });
      };

      const mockResultsProveedores = (keyword) => {
        return new Promise((res, rej) => {
          setTimeout(() => {
            const searchResults = dataProveedores.filter((item) => item.nombre.toUpperCase().includes(keyword.toUpperCase()));
            res(searchResults);
          }, 500);
        });
      };

      const mockResultsProducto = (keyword) => {
        return new Promise((res, rej) => {
          setTimeout(() => {
            const searchResults = dataNombresProductos.filter((item) => item.nombre_producto.toUpperCase().includes(keyword.toUpperCase()));
            res(searchResults);
          }, 500);
        });
      };

      const handleInputChange = (e,tipo) => {
        const nameValue = e.target.value;

        if(tipo==='cliente'){
        setName(nameValue);
        setIsNameSelected(false);
        setResults([]);
        } else if(tipo==='proveedor'){
            setNameproveedores(nameValue);
            setIsNameSelectedproveedores(false);
            setResultsproveedores([]);
        } else if(tipo==='producto'){
            setNameproducto(nameValue);
            setIsNameSelectedproducto(false);
            setResultsproducto([]);
        }

        if (nameValue.length > 1) {
          setIsLoading(true);
          if(tipo==='cliente'){
          mockResultsClientes(nameValue)
            .then((res) => {
              setResults(res);
              setIsLoading(false);
            })
            .catch(() => {
              setIsLoading(false);
            });}
            else if(tipo==='proveedor'){
                mockResultsProveedores(nameValue)
                  .then((res) => {
                    setResultsproveedores(res);
                    setIsLoading(false);
                  })
                  .catch(() => {
                    setIsLoading(false);
                  });}
                  else if(tipo==='producto'){
                    mockResultsProducto(nameValue)
                      .then((res) => {
                        setResultsproducto(res);
                        setIsLoading(false);
                      })
                      .catch(() => {
                        setIsLoading(false);
                      });}
        }
      };
    
      const onNameSelected = (selectedName,tipo) => {
        if(tipo==='cliente'){
        setName(selectedName);
        setIsNameSelected(true);
        setResults([]);
        }
        else if(tipo==='proveedor'){
            setNameproveedores(selectedName);
        setIsNameSelectedproveedores(true);
        setResultsproveedores([]);
        }
        else if(tipo==='producto'){
            setNameproducto(selectedName);
        setIsNameSelectedproducto(true);
        setResultsproducto([]);
        }
      };

      const handleChangeConteiner = (e,tipo) => {
        const { name, value } = e.target;

        if(tipo==='cliente')
        setContainers(value);
        else if(tipo==='proveedor')
        setContainersproveedores(value);       
        else if(tipo==='proforma')
        setContainersproforma(value);   
        else if(tipo==='producto')
            setContainersproducto(value);   
    };
 

      const handleAgregarCliente = async () => {

        const idCliente = name!=='' ? dataClientes.find((item) => item.nombre===name)?.id_cliente : -1;

            print(`handleAgregarCliente containers ${containers} cliente ${idCliente}`);

const token = localStorage.getItem('token');
if(idCliente!==-1){
        try {
            const response = await fetch(`${urlApiProd}/addbookingcliente`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    'id_booking' : formData.id_solicitud,
                    'id_cliente' : idCliente,
                    'cantidad_contenedores' : containers,
                })
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Error al agregar registro');
            } else{
                fetchDataClientesBooking();
                setContainers('');
                setName('');
                setIsNameSelected(false);

                const respuesta = await response.json();
                print(`response.json() ${respuesta.id}`);
            }
        }
            catch(error){
            print(`Error: ${error}`);
            alert('No se pudo agregar la registro');
            }} else{
                alert('No se pudo agregar registro');
            }

      };

      const handleAgregarProveedor = async () => {

        const id = nameproveedores!=='' ? dataProveedores.find((item) => item.nombre===nameproveedores)?.id_proveedor : -1;

            print(`handleAgregarProveedor containers ${containersproveedores} cliente ${id}`);

            if(id!==-1){
            const data = JSON.stringify({
                'id_booking' : formData.id_solicitud,
                'id_proveedor' : id,
                'cantidad_contenedores' : containersproveedores,
                'reducido' : 'no',
                'motivo' : '',
            });

          const resultado =  await handleAgregar('addbookingproveedor',data);
          if(resultado==="Agregado correctamente"){
            fetchDataBookingProveedor();
                setContainersproveedores('');
                setNameproveedores('');
                setIsNameSelectedproveedores(false);
          }
          alert(resultado);
        } else{alert("No fue posible agregar registro");}
      };

      const handleAgregarProforma = async () => {

            print(`handleAgregarProforma containers ${containersproforma} n° proforma ${proformaID}`);

            const data = JSON.stringify({
                'id_booking' : formData.id_solicitud,
                'correlativo_proforma' : proformaID,
                'cantidad_contenedores' : containersproforma,
            });

          const resultado =  await handleAgregar('addbookingproforma',data);
          if(resultado==="Agregado correctamente"){
            fetchDataBookingProformas();
                setProformaID('');
                setContainersproforma('');
          }
          alert(resultado);
      };

      const handleAgregarProducto = async () => {

        const id = nameproducto!=='' ? dataNombresProductos.find((item) => item.nombre_producto===nameproducto)?.id_producto : -1;

        print(`handleAgregarProducto containers ${containersproducto} n° proforma ${id}`);

        if(id!==-1){
        const data = JSON.stringify({
            'id_booking' : formData.id_solicitud,
            'id_producto' : id,
            'cantidad_contenedores' : containersproducto,
        });

      const resultado =  await handleAgregar('addbookingproducto',data);
      if(resultado==="Agregado correctamente"){
        //fetchDataBookingProductos();
                setContainersproducto('');
                setNameproducto('');
                setIsNameSelectedproducto(false);
      }
      alert(resultado);
    } else{ alert("No fue posible agregar")}
  };

      

      const handleEliminarBookingContenedor = async (id) => {
       const resultado = await handleEliminar(id,"delete_bookingcontenedor");
       fetchDataBookingContenedor();
       alert(resultado);
          };

          const handleEliminarBookingFecha = async (id) => {
            const resultado = await handleEliminar(id,"deletebookingfecha");
            fetchDataBookingFecha();
            alert(resultado);
               };

            
            const handleAgregarDetalle = async () => {

                const idProducto = nameproducto!=='' ? dataNombresProductos.find((item) => item.nombre_producto===nameproducto)?.id_producto : -1;
                const idProveedor = nameproveedores!=='' ? dataProveedores.find((item) => item.nombre===nameproveedores)?.id_proveedor : -1;
                const idCliente = name!='' ? dataClientes.find((item) => item.nombre===name)?.id_cliente : -1;
        
                if(containers!=='' && proformaID!=='' && idProducto!==-1 && idProveedor!==-1 && idCliente!==-1){
                const data = JSON.stringify({
                    'id_booking' : formData.id_solicitud,
                    'id_cliente' : idCliente,
                    'id_proveedor' : idProveedor,
                    'correlativo_contrato' : proformaID,
                    'id_producto' : idProducto,
                    'cantidad_contenedores' : containers,
                });
        
              const resultado =  await handleAgregar('addbookingcontenedor',data);
              if(resultado==="Agregado correctamente"){
                fetchDataBookingContenedor();
                setContainers('');
                setName('');
                setIsNameSelected(false);
                setNameproveedores('');
                setIsNameSelectedproveedores(false);
                setProformaID('');
                setNameproducto('');
                setIsNameSelectedproducto(false);

              }
              alert(resultado);
            } else{ alert("No fue posible agregar, favor revisar datos")}
          };

          const handleAgregarFechas = async () => {

            if(nombreContenedor!=='' || fechaRetiro!=='' || fechaIngresoPuerto!==''){

                const data = JSON.stringify({
                    'id_booking' : formData.id_solicitud,
                    'nombre_contenedor' : nombreContenedor,
                    'fecha_retiro' : fechaRetiro==='' ? null : fechaRetiro,
                    'fecha_ingreso_puerto' : fechaIngresoPuerto==='' ? null : fechaIngresoPuerto,
                });
        
    
          const resultado =  await handleAgregar('addbookingfecha',data);
          if(resultado==="Agregado correctamente"){
            fetchDataBookingFecha();
            setnombreContenedor('');
            setfechaRetiro('');
            setfechaIngresoPuerto('');
          }
          alert(resultado);
        } else{ alert("No fue posible agregar, favor revisar datos")}
      };


      const handleChangeNombreContenedor = (e) => {
        const { name, value } = e.target;
        setnombreContenedor(value);
    };
    const handleChangefechaRetiro = (e) => {
        const { name, value } = e.target;
        setfechaRetiro(value);
    };
    const handleChangefechaIngresoPuerto = (e) => {
        const { name, value } = e.target;
        setfechaIngresoPuerto(value);
    };
    const [showEditarFechaBooking, setShowEditarFechaBooking] = React.useState(false);
      
    const handleCloseEditarFechaBooking = () => setShowEditarFechaBooking(false);
    const handleShowEditarFechaBooking = () => setShowEditarFechaBooking(true);
const EditarFechaBooking = () => {

      
        return (
          <>
           <button  style={{ flex: 1, marginRight: 10 }}
                                              className='btn btn-outline-warning'
                                                 onClick={() => {
                                                    handleShowEditarFechaBooking();
                                                          }}>
                                                                        <LuPencilLine />
                                                                    </button>
      
            <Modal show={showEditarFechaBooking} onHide={handleCloseEditarFechaBooking} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>Editar Fecha Booking</Modal.Title>
              </Modal.Header>
              <Modal.Body>
           
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseEditarFechaBooking}>
                  Volver
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        );
      };

      const handleModificarFechaBooking = () => {};

    return (
        <Modal dialogClassName="my-modal" size='xl' aria-labelledby="contained-modal-title-vcenter"
        centered show={show} onHide={handleClose} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>{formData.nro_booking.trim()==='' ? 'Gestión de Booking' : `Gestión de Booking N° ${formData.nro_booking}`}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              {loading  ? (
                            <div className="text-center">
                                <Spinner animation="border" role="status" />
                                <span className="sr-only">Cargando...</span>
                            </div>
                        ) : ( <><Form onSubmit={handleSubmit}>         
                    
   <div className="">
  <div className="row">
    <div className="col-4">
    <div className="mb-3">
                                <label className="form-label">Solicitud Interna Asociada</label>
                                <h4>{formData.solicitud_interna.codigo}</h4>
                            </div>
        </div>
        <div className="col-4">
        <div className="mb-3">
                                <label className="form-label">Estado de Booking {formData.estado.toString()==='0'? '🔴' : formData.estado.toString()==='1' ? '🟡' : formData.estado.toString()==='2' ? '🔵' : formData.estado.toString()==='3' ? '🟢' : formData.estado.toString()==='-1' ? '⚫' : formData.estado===99 ? '⚪' : ''}</label>
                                <select className="form-select" name="estado" onChange={handleChange} value={formData.estado}
                                 style={{backgroundColor:'black !important'}}>
                                    <option key="Confirmado" value="2">Confirmado</option>
                                    <option key="Embarcado" value="3">Embarcado</option>   
                                    <option key="Cancelado" value="-1">Cancelado</option>
                                    <option key="Transferencia" value="99">Transferencia</option>   

                                </select>
                            </div>
        </div>
        <div className="col-4 text-center">
            <Button variant="primary" size="lg" onClick={handleSubmit} style={{marginTop:5}}>
                        Actualizar Booking
                        </Button>
                        <div>{erroresForm}</div>
</div>
       <p></p>
       <hr></hr>
        </div>
        <div className="row">
    <div className="col-md-1" style={{width: '12%'}}>   
    <div className="mb-3">
                                <label className="form-label">N° Booking</label>
                                <input type="text" step="0.01" className="form-control" name="nro_booking" onChange={handleChange} value={formData.nro_booking} />
                            </div>      
                                
    </div>
    
    <div className="col-md-1" style={{width: '12%'}}>
    <div className="mb-3">
                                <label className="form-label">FFW</label>
                                <select
                                    className="form-select"
                                    name="id_ffw"
                                    onChange={(e) => handleChange({ target: { name: "id_ffw", value: e.target.value || null } })}
                                    value={formData.id_ffw || ""}
                                >
                                    {ffw.map((item) => (
                                        <option key={item.id_ffw} value={item.id_ffw}>
                                            {item.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
    </div>
    <div className="col-md-1" style={{width: '12%'}}>
    {formData.id_ffw === null || formData.id_ffw === "" ? (
                                <div className="mb-3">
                                    <label className="form-label">Carrier</label>
                                    <select
                                        className="form-select"
                                        name="id_carrier"
                                        onChange={handleChange}
                                        value={formData.id_carrier}
                                    >
                                        <option value="">Seleccione un Carrier</option>
                                        {carriers
                                            .filter((carrier) => carrier.tipo === 2) // Filtra los carriers tipo 2
                                            .map((item) => (
                                                <option key={item.id_carrier} value={item.id_carrier}>
                                                    {item.nombre}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            ) : (
                                <div className="mb-3">
                                    <label className="form-label">Carrier</label>
                                    <select
                                        className="form-select"
                                        name="id_carrier"
                                        onChange={handleChange}
                                        value={formData.id_carrier}
                                    >
                                        <option value="">Seleccione un Carrier</option>
                                        {carriers
                                            .filter((carrier) => carrier.tipo === 1) // Filtra los carriers tipo 1
                                            .map((item) => (
                                                <option key={item.id_carrier} value={item.id_carrier}>
                                                    {item.nombre}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            )}
                           
    </div>
    
  <div className="col-md-1" style={{width: '6%'}}>
  <div className="mb-3">
                                <label className="form-label">FTO</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="ftorigen"
                                    onChange={handleChange}
                                    value={formData.ftorigen}
                                    placeholder="Días"
                                    required
                                />
                            </div>
 
  </div>
  <div className="col-md-1" style={{width: '6%'}}>
  <div className="mb-3">
                                <label className="form-label">FTD </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="ftdestino"
                                    onChange={handleChange}
                                    value={formData.ftdestino}
                                    placeholder="Días"
                                    required
                                />
                            </div>
  </div>
  <div className="col-md-1" style={{width: '11%'}}>
  <div className="mb-3">
                                <label className="form-label">DLD</label>
                                <input type="date" className="form-control" name="dld" onChange={handleChange} value={formData.dld}/>
                            </div>
  </div>
  <div className="col-md-1" style={{width: '12%'}}>
  <div className="mb-3">
                                <label className="form-label">Nave</label>
                                <input type="text"  className="form-control" name="nave" onChange={handleChange} value={formData.nave} required />
                            </div>
    </div>
    <div className="col-md-1" style={{width: '11%'}}>
    
    <div className="mb-3">
                                <label className="form-label">DLC</label>
                                <input type="date" className="form-control" name="dlc" onChange={handleChange} value={formData.dlc}/>
                            </div>
                           
                           
    </div>
    <div className="col-md-1" style={{width: '11%'}}>
    <div className="mb-3">
                                <label className="form-label">ETD</label>
                                <input type="date" className="form-control" name="etd" onChange={handleChange} value={formData.etd} required />
                            </div>
    </div>
    <div className="col-md-1" style={{width: '6%'}}>
    <div className="mb-3">
                                <label className="form-label">HC</label>
                                <input type="number" className="form-control" name="cantidad" onChange={(e) => handleChangeCantidad(e, 100)} value={formData.cantidad} min="1" maxLength="2"  required />
                            </div>
                           
    </div>
  </div>
  <div className="row">
 {/*} <div className="col">
  <div className="mb-3">
        <label className="form-label">Estado de BL</label>
              <input type="date" defaultValue='' className="form-control" name="estado_bl" onChange={handleChange} value={formData.estado_bl}/>
    </div>
  </div> */}
   <div className="col-md-1" style={{width: '11%'}}>
    
    <div className="mb-3">
                                <label className="form-label">ETA</label>
                                <input type="date" className="form-control" name="eta" onChange={handleChange} value={formData.eta}/>
                            </div>
                           
                           
    </div>
  <div className="col">    <div className="mb-3">
                                <label className="form-label">Categoría</label>
                                <select className="form-select" name="categoria_booking" onChange={handleChange} value={formData.categoria_booking}>
                                <option value="-1">Seleccione categoría</option>
                                <option key="Lamina" value="1">
                                Lamina</option>  
                                <option key="Madera" value="2">
                                 Madera</option>
                                 <option key="Terciado" value="3">
                                 Terciado</option>   
                                    

                                </select>
                            </div>
                            </div>
                            <div className="col">   <div className="mb-3">
                                <label className="form-label">Cross Docking</label>
                                <select className="form-select" name="cross_docking" onChange={handleChange} value={formData.cross_docking}>
                                <option value="-1">Seleccione si es Cross Docking</option>
                                <option key="Si" value="si">
                                Si</option>  
                                <option key="No" value="no">
                                 No</option> 
                                </select>
                            </div>
                            </div>                         
  <div className="col">   <div className="mb-3">
                                <label className="form-label">MAPA</label>
                                <select className="form-select" name="mapa" onChange={handleChange} value={formData.mapa}>
                                <option value="-1">Seleccione si es MAPA</option>
                                <option key="Si" value="si">
                                Si</option>  
                                <option key="No" value="no">
                                 No</option> 
                                </select>
                            </div>
                            </div>
                            {formData.estado.toString()==='3' ? (
                            <div className="col">   <div className="mb-3">
                                <label className="form-label">Invoice</label>
                                <input type="number" className="form-control" onChange={(e) => handleChangeCantidad(e, 10000)} name="invoice" value={formData.invoice} />
                            </div>
                            </div>) : <></>}
  <div className="col">
  <div className="col text-center">
                            
                            <GuardarArchivo/>

                            </div>
  </div>
  </div>
        </div> </Form>
        <p></p>
<hr></hr>
<Accordion defaultActiveKey={desde==='bookingexterno' ? "0" : "-1"}>
      <Accordion.Item eventKey="0">
        <Accordion.Header>Fechas de Booking</Accordion.Header>
        <Accordion.Body>
        {desde==='bookingexterno' ? (
        <Form>
            <Row>
            <Form.Group className="typeahead-form-group" as={Col}>
           <Form.Label>Nombre de Contenedor</Form.Label>
           <Form.Control
          type="text"                      
          onChange={handleChangeNombreContenedor}
          value={nombreContenedor}
        />
      </Form.Group>
            <Form.Group className="typeahead-form-group" as={Col}>
           <Form.Label>Fecha de Retiro</Form.Label>
        <Form.Control
          type="date"                      
          onChange={handleChangefechaRetiro}
          value={fechaRetiro}
        />
      </Form.Group>
      <Form.Group className="typeahead-form-group" as={Col}>
           <Form.Label>Fecha de Ingreso al Puerto</Form.Label>
        <Form.Control
          type="date"                      
          onChange={handleChangefechaIngresoPuerto}
          value={fechaIngresoPuerto}
        />
      </Form.Group>
      <Form.Group as={Col} xs="auto">
           <Button variant="primary" onClick={handleAgregarFechas} style={{marginTop:25}}>
                       Guardar
                       </Button>  </Form.Group>
      </Row>
      </Form>
      ) :(<></>)}   
      <p></p>
    
                                {dataBookingFecha.length>0 ? (<Table striped bordered hover>
                                    <tbody>
                                    <tr>
                                    <th>Nombre Contenedor</th>
                                    <th>Fecha de Retiro</th>
                                    <th>Fecha de Ingreso al Puerto</th>
                                    {desde==='bookingexterno' ? ( <th>Acciones</th>) : (<></>) }                                   
                                     </tr>
                             
                                    {dataBookingFecha.map((object, i) => <tr><td>{object.nombre_contenedor}</td>
                                    <td>{object.fecha_retiro}</td><td>{object.fecha_ingreso_puerto}</td>
                                    {desde==='bookingexterno' ? (  <td>

                                 {/*  <EditarFechaBooking/> */}
                                    
                                      
                                        <button 
                                              className='btn btn-outline-danger'
                                                 onClick={() => {
                                                    if (window.confirm('¿Estás seguro de eliminar este registro?')) {
                                                        handleEliminarBookingFecha(object.id);
                                                           }
                                                          }}
                                                                    >
                                                                        <IoTrashOutline />
                                                                    </button></td>) : (<></>)}
                                        </tr>)}

                                    </tbody>
                               </Table>) : (<div>No hay datos que mostrar</div>) }
                               
   
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
<p></p>
<hr></hr>
        <Card>
        <Card.Header as="h5">Asignación de Booking</Card.Header>
            <Card.Body> 
                {desde==='solicitudesinternas' ? (
        <Form>
            <Row>
            <Form.Group className="typeahead-form-group" as={Col}>
           <Form.Label>Cliente </Form.Label>
        <Form.Control
          type="text"
          autoComplete="off"
          placeholder="Buscar Cliente"                              
          onChange={(e) => handleInputChange(e,'cliente')}
          value={name}
        />
        <ListGroup className="typeahead-list-group">
          {!isNameSelected &&
            results.length > 0 &&
            results.map((result) => (
              <ListGroup.Item
                key={result.id_cliente}
                className="typeahead-list-group-item"
                onClick={() => onNameSelected(result.nombre,'cliente')}
              >
                {result.nombre}
              </ListGroup.Item>
            ))}
        </ListGroup>
      </Form.Group>


            <Form.Group as={Col}>
           <Form.Label>Correlativo Contrato</Form.Label>
        <Form.Control
          type="text"
          placeholder="N° Correlativo"                              
          onChange={(e) => setProformaID(e.target.value)}
          value={proformaID}
        />
      </Form.Group>

      <Form.Group className="typeahead-form-group" as={Col}>
           <Form.Label>Producto </Form.Label>
        <Form.Control
          type="text"
          autoComplete="off"
          placeholder="Buscar Producto"                              
          onChange={(e) => handleInputChange(e,'producto')}
          value={nameproducto}
        />
        <ListGroup className="typeahead-list-group">
          {!isNameSelectedproducto &&
            resultsproducto.length > 0 &&
            resultsproducto.map((result) => (
              <ListGroup.Item
                key={result.id_producto}
                className="typeahead-list-group-item"
                onClick={() => onNameSelected(result.nombre_producto,'producto')}
              >
                {result.nombre_producto}
              </ListGroup.Item>
            ))}
        </ListGroup>
      </Form.Group>

           <Form.Group className="typeahead-form-group" as={Col}>
           <Form.Label>Proveedor </Form.Label>
        <Form.Control
          type="text"
          autoComplete="off"
          placeholder="Buscar Proveedor"                              
          onChange={(e) => handleInputChange(e,'proveedor')}
          value={nameproveedores}
        />
        <ListGroup className="typeahead-list-group">
          {!isNameSelectedproveedores &&
            resultsproveedores.length > 0 &&
            resultsproveedores.map((result) => (
              <ListGroup.Item
                key={result.id_proveedor}
                className="typeahead-list-group-item"
                onClick={() => onNameSelected(result.nombre,'proveedor')}
              >
                {result.nombre}
              </ListGroup.Item>
            ))}
        </ListGroup>
      </Form.Group>

         <Form.Group as={Col}>
        <Form.Label>Cantidad HC</Form.Label>
        <Form.Control  placeholder="Cant. Contenedores" value={containers} onChange={(e) => handleChangeConteiner(e,'cliente')} />
      </Form.Group>

      <Form.Group as={Col} xs="auto">
           <Button variant="primary" onClick={handleAgregarDetalle} style={{marginTop:25}}>
           Guardar
                       </Button>  </Form.Group>
      </Row>
            </Form>       ) :(<></>)}   
<p></p>
    
                                {dataBookingContenedor.length>0 ? (<Table striped bordered hover>
                                    <tbody>
                                    <tr>
                                    <th>Cliente</th>
                                    <th>Contrato</th>
                                    <th>Producto</th>
                                    <th>Proveedor</th>
                                    <th>HC</th>
                                    {desde==='solicitudesinternas' ? ( <th>Acciones</th>) : (<></>)}
                                    </tr>
                             
                                    {dataBookingContenedor.map((object, i) => <tr><td>{dataClientes.find((item) => item.id_cliente===object.id_cliente)?.nombre}</td><td>{object.correlativo_contrato}</td>
                                    <td>{dataNombresProductos.find((item) => item.id_producto===object.id_producto)?.nombre_producto}</td>
                                    <td>{dataProveedores.find((item) => item.id_proveedor===object.id_proveedor)?.nombre}</td><td>{object.cantidad_contenedores}</td>
                                    {desde==='solicitudesinternas' ? ( <td>

                                      
                                        <button 
                                              className='btn btn-outline-danger'
                                                 onClick={() => {
                                                    if (window.confirm('¿Estás seguro de eliminar este registro?')) {
                                                        handleEliminarBookingContenedor(object.id);
                                                           }
                                                          }}
                                                                    >
                                                                        <IoTrashOutline />
                                                                    </button></td>) : (<></>)}
                                        </tr>)}

                                    </tbody>
                               </Table>) : (<div>No hay datos que mostrar</div>) }
                               </Card.Body>
                               </Card>
       <p></p>

        <Accordion defaultActiveKey="-2">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Historia<Badge bg="danger" style={{marginLeft: 10}}>
                                            </Badge></Accordion.Header>
        <Accordion.Body>
        <Table striped bordered hover>
                                <tbody>
                                    <tr>
                                    <th>Usuario Creador</th>
                                    <th>Fecha Creación</th>
                                    </tr>
                                    <tr>
                                    <td>{usuarioCreador}</td>
                                    <td>{formData.fecha_creacion}</td>
                                    </tr>
                                    </tbody>
                                    </Table>
                                {dataHistoria.length>0 ? (<Table striped bordered hover>
                                    <tbody>
                                    <tr>
                                    <th>Usuario Actualiza</th>
                                    <th>Fecha</th>
                                    <th>Datos</th>
                                    </tr>
                             
                                    {dataHistoria.map((object, i) => <tr><td>{object.usuario_modifica.split('@')[0]}</td><td>{object.fecha}</td>
                                    <td>
                                    {Object.keys(object.objeto_anterior).map((key)=>{
                                         if(key!=='solicitud_interna' && object.objeto_anterior[key]!==object.objeto_actual[key])
                                            return (<div><b>{capitalizeFirstLetter(key.replace('_',' '))}</b><br></br>Antiguo: {(object.objeto_anterior[key]===null ? 'sin dato' : object.objeto_anterior[key]===true ? 'activado' : object.objeto_anterior[key]===false ? 'desactivado' : key==='estado' ? (object.objeto_anterior[key].toString()==="0" ? 'Pendiente' : object.objeto_anterior[key].toString()==="1" ? 'Solicitado' : object.objeto_anterior[key].toString()==="2" ? 'Confirmado' : object.objeto_anterior[key].toString()==="3" ? 'Embarcado' : object.objeto_anterior[key].toString()==="-1" ? 'Cancelado' : object.objeto_anterior[key].toString()==="99" ? 'Transferencia' : 'Sin estado') : key==='categoria_booking' ? (object.objeto_anterior[key].toString()==="1" ? 'Lamina' : object.objeto_anterior[key].toString()==="2" ? 'Madera' : object.objeto_anterior[key].toString()==="3" ? 'Terciado' : 'Sin categoria') : key==='id_ffw' ? (ffw.find(f => f.id_ffw.toString() === object.objeto_anterior[key].toString())?.nombre || '') : key==='id_carrier' ? (carriers.find(f => f.id_carrier.toString() === object.objeto_anterior[key].toString())?.nombre || '') : object.objeto_anterior[key])+""} , Nuevo: {(object.objeto_actual[key]===null ? 'sin dato' : object.objeto_actual[key]===true ? 'activado' : object.objeto_actual[key]===false ? 'desactivado' : key==='estado' ? (object.objeto_actual[key].toString()==="0" ? 'Pendiente' : object.objeto_actual[key].toString()==="1" ? 'Solicitado' : object.objeto_actual[key].toString()==="2" ? 'Confirmado' : object.objeto_actual[key].toString()==="3" ? 'Embarcado' : object.objeto_actual[key].toString()==="-1" ? 'Cancelado' : object.objeto_actual[key].toString()==="99" ? 'Transferencia' : 'Sin estado') : key==='categoria_booking' ? (object.objeto_actual[key].toString()==="1" ? 'Lamina' : object.objeto_actual[key].toString()==="2" ? 'Madera' : object.objeto_actual[key].toString()==="3" ? 'Terciado' : 'Sin categoria') : key==='id_ffw' ? (ffw.find(f => f.id_ffw.toString() === object.objeto_actual[key].toString())?.nombre || '') : key==='id_carrier' ? (carriers.find(f => f.id_carrier.toString() === object.objeto_actual[key].toString())?.nombre || '') : object.objeto_actual[key])+""}</div>);
                                    })}
                                    </td>
                                        </tr>)}

                                    </tbody>
                               </Table>) : (<></>) }
                               
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>

      </>)}      
                 


              </Modal.Body>
            </Modal>
    );
};

export default GestionCPO;
